var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/GroupEnums';
let GroupModule = class GroupModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.groupList = [];
        this.groupCode = [];
        this.groupDesc = [];
        this.selectedCategoryCode = [];
        this.selectedCategoryDesc = [];
        this.isActive = true;
        this.useFilter = true;
        this.groupPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.status = '';
        this.statusMessage = '';
        this.searchBy = '';
    }
    get getGroupWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getGroupLoading() {
        return this.loading;
    }
    get getGroupDataList() {
        return this.groupList;
    }
    get getGroupListCode() {
        return this.groupCode;
    }
    get getGroupListDesc() {
        return this.groupDesc;
    }
    get getGroupSelectedCode() {
        return this.selectedCategoryCode;
    }
    get getGroupSelectedDesc() {
        return this.selectedCategoryDesc;
    }
    get getGroupActive() {
        return this.isActive;
    }
    get getGroupPaging() {
        return this.groupPaging;
    }
    get getGroupSize() {
        return this.size;
    }
    get getGroupStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getGroupUseFilter() {
        return this.useFilter;
    }
    get getGroupWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getGroupDesc() {
        return this.desc;
    }
    get getGroupSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_GROUP_WAS_FIRST_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_GROUP_LOADING](payload) {
        this.loading = payload;
    }
    [_c = Mutations.SET_GROUP_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_d = Mutations.SET_GROUP_LIST](payload) {
        this.groupList = payload;
    }
    [_e = Mutations.SET_GROUP_LIST_CODE](payload) {
        this.groupCode = payload;
    }
    [_f = Mutations.SET_GROUP_LIST_DESC](payload) {
        this.groupDesc = payload;
    }
    [_g = Mutations.SET_SELECTED_GROUP_CODE](payload) {
        this.selectedCategoryCode = payload;
    }
    [_h = Mutations.SET_SELECTED_GROUP_DESC](payload) {
        this.selectedCategoryDesc = payload;
    }
    [_j = Mutations.SET_SELECTED_GROUP_ACTIVE](payload) {
        this.isActive = payload;
    }
    [_k = Mutations.SET_GROUP_PAGE](payload) {
        this.groupPaging = payload;
    }
    [_l = Mutations.SET_GROUP_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_m = Mutations.SET_GROUP_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_o = Mutations.SET_GROUP_SIZE](payload) {
        this.size = payload;
    }
    [_p = Mutations.SET_GROUP_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_q = Mutations.SET_GROUP_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_r = Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_s = Mutations.SET_GROUP_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_t = Mutations.SET_GROUP_SEARCH_KEY](payload) {
        this.desc = payload;
    }
    [_u = Actions.GET_GROUP_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_GROUP_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL + `/fincapex/api/master/group`;
            const params = {
                ver: 'v1',
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_GROUP_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_GROUP_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_GROUP_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_GROUP_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_GROUP_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_GROUP_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_v = Actions.GET_GROUP_LIST_CODE_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/group/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                groupCode: [],
                groupDesc: [],
                isActive: this.isActive
            };
            const dataCode = [...this.groupCode];
            const dataDesc = [...this.groupDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataCode.push({
                                    value: data.groupCode,
                                    label: data.groupCode
                                });
                                dataDesc.push({
                                    value: data.groupDesc,
                                    label: data.groupDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_GROUP_LIST_CODE, dataCode);
                        this.context.commit(Mutations.SET_GROUP_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_GROUP_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_w = Actions.CREATE_GROUP_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL + `/fincapex/api/master/group?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_GROUP_LIST_CODE, []);
                        this.context.commit(Mutations.SET_GROUP_LIST_DESC, []);
                        this.context.commit(Mutations.SET_GROUP_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_GROUP_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_GROUP_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_GROUP_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_x = Actions.UPDATE_GROUP_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL + `/fincapex/api/master/group?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_GROUP_LIST_CODE, []);
                        this.context.commit(Mutations.SET_GROUP_LIST_DESC, []);
                        this.context.commit(Mutations.SET_GROUP_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_GROUP_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_GROUP_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_GROUP_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_y = Actions.GET_GROUP_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_GROUP_CODE, data.groupCode);
            this.context.commit(Mutations.SET_SELECTED_GROUP_DESC, data.groupDesc);
            this.context.commit(Mutations.SET_SELECTED_GROUP_ACTIVE, data.isActive);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/group/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: '',
                SearchBy: '',
                groupCode: data.groupCode,
                groupDesc: data.groupDesc,
                isActive: data.isActive
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _9, _10, _11;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_GROUP_LIST, ((_9 = res.data.result.content) === null || _9 === void 0 ? void 0 : _9.data) || []);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_GROUP_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_GROUP_PAGE, ((_10 = res.data.result.content) === null || _10 === void 0 ? void 0 : _10.paging) || {
                                currentPage: 0,
                                totalPages: 0,
                                totalElements: 0,
                                errorRows: 0,
                                readyToUpload: 0
                            });
                        }
                        this.context.commit(Mutations.SET_GROUP_PAGE, ((_11 = res.data.result.content) === null || _11 === void 0 ? void 0 : _11.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_z = Actions.DOWNLOAD_GROUP]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/group/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    groupCode: this.selectedCategoryCode,
                    groupDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_0 = Actions.UPDATE_GROUP_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_GROUP_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_1 = Actions.GET_GROUP_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_GROUP_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_GROUP_LIST_FILTER, {
                    groupCode: this.selectedCategoryCode,
                    groupDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                });
            }
        });
    }
    [_2 = Actions.UPDATE_SELECTED_GROUP_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_GROUP_CODE, data);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_GROUP_DATA);
        });
    }
    [_3 = Actions.UPDATE_SELECTED_GROUP_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_GROUP_DESC, data);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_GROUP_DATA);
        });
    }
    [_4 = Actions.UPDATE_SELECTED_GROUP_ACTIVE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_GROUP_ACTIVE, data);
            this.context.commit(Mutations.SET_SELECTED_GROUP_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_GROUP_DESC, []);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_GROUP_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_GROUP_DATA);
            this.context.dispatch(Actions.GET_GROUP_LIST_CODE_DESC);
        });
    }
    [_5 = Actions.UPDATE_GROUP_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_GROUP_SIZE, data);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_GROUP_DATA);
        });
    }
    [_6 = Actions.RESET_GROUP_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_GROUP_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_GROUP_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_GROUP_ACTIVE, true);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_GROUP_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_GROUP_DATA);
            this.context.dispatch(Actions.GET_GROUP_LIST_CODE_DESC);
        });
    }
    [_7 = Actions.UPDATE_SEARCH_GROUP_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_GROUP_SEARCH_BY, 'GroupDesc');
            this.context.commit(Mutations.SET_GROUP_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_GROUP_LIST_DESC, []);
            this.context.dispatch(Actions.GET_GROUP_LIST_CODE_DESC);
        });
    }
    [_8 = Actions.UPDATE_SEARCH_GROUP_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_GROUP_SEARCH_BY, 'GroupCode');
            this.context.commit(Mutations.SET_GROUP_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_GROUP_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_GROUP_LIST_CODE, []);
            this.context.dispatch(Actions.GET_GROUP_LIST_CODE_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _x, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _y, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _z, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _0, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _1, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _2, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _3, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _4, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupModule.prototype, _8, null);
GroupModule = __decorate([
    Module
], GroupModule);
export default GroupModule;
